// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__17wpV","buttonsContainer":"Footer_buttonsContainer__14_IZ","button":"Footer_button__1wpEc"};